export default __webpack_public_path__ + "static/media/upload-folder-upper-jaw.6bd162f3.svg";